import classNames from 'classnames';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { MEDIA_POPOVERS_TABS_NAMES_BI, MEDIA_POPOVERS_BUTTONS_NAMES_BI } from 'wix-rich-content-common';
import { ModalHeaderWithCloseButton, SettingsMobileHeader, Tabs, Tab } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { ADD_AUDIO_MODAL, EMBED_TAB_AUDIO_INPUT } from '../dataHooks.js';
import AudioUploadModal from './AudioUploadModal.js';
import MediaURLInputModal from './MediaURLInputModal.js';
import { isSoundcloudUrl } from './utils.js';
import { AUDIO_TYPE } from 'ricos-content';
import 'wix-rich-content-plugin-commons';
import '../consts.js';
import 'ricos-types';
import '../toolbar/audioPluginService.js';
import 'lodash';

var css_248z = ".LWTch{height:fit-content;min-width:321px;position:relative}[dir] .LWTch{margin-top:-15px}.LWTch.OE6i6{height:calc(100vh - 100px);overflow-x:hidden;overflow-y:auto;position:absolute;top:0;width:100%}[dir] .LWTch.OE6i6{margin:0}[dir=ltr] .LWTch.OE6i6{left:0}[dir=rtl] .LWTch.OE6i6{right:0}.gYv-G{position:relative;width:calc(100% + 40px)}[dir=ltr] .gYv-G{margin-left:-20px}[dir=rtl] .gYv-G{margin-right:-20px}.OE6i6 .gYv-G{width:100%}[dir] .OE6i6 .gYv-G{margin:0}.ChqR8{box-sizing:border-box}[dir] .ChqR8{padding:16px 20px 0}.ChqR8 *,.ChqR8 :after,.ChqR8 :before{box-sizing:inherit}.ChqR8 input{box-sizing:border-box}.OE6i6 .ChqR8{position:absolute;top:100px;width:100%}[dir] .OE6i6 .ChqR8{background-color:#fff;padding:20px}.ChqR8.Evefd{height:154px;max-width:420px}.ChqR8 :not(.OE6i6).Evefd{min-width:341px}.JAQfV{height:.1px;opacity:0;overflow:hidden;position:absolute;width:.1px;z-index:-1}.smYQT{display:inline-block;height:40px;width:108px}[dir] .smYQT{border:none}[dir=ltr] .smYQT{margin-left:12px}[dir=ltr] .smYQT,[dir=rtl] .smYQT{padding-left:24px;padding-right:24px}[dir=rtl] .smYQT{margin-right:12px}.OE6i6 .smYQT{flex-direction:column;gap:24px}[dir] .OE6i6 .smYQT{margin-bottom:0}._2et7i{align-items:center;display:flex;font-size:16px;height:100%;justify-content:center;width:100%}[dir] ._2et7i{cursor:pointer}.JgZCt{position:absolute;top:50px;width:100%;z-index:2}[dir] .JgZCt{background-color:#fff}";
var styles = {"audio_modal_container":"LWTch","audio_modal_mobile":"OE6i6","audio_modal_content":"gYv-G","audio_modal_tab":"ChqR8","audio_upload_tab":"Evefd","fileInput":"JAQfV","audio_modal_add_button_inline":"smYQT","fileInputLabel":"_2et7i","audio_tabs_headers":"JgZCt"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AudioInsertModal = (props) => {
  var _a;
  const {
    componentData = {},
    closeModal,
    t,
    isMobile,
    embedType = false,
    onConfirm,
    setData,
    languageDir,
    onReplace,
    helpers = {},
    showCloseButton
  } = props;
  const src = (_a = componentData == null ? void 0 : componentData.audio) == null ? void 0 : _a.src;
  const audioTabs = { embed: t("MediaModal_Tabs_Embed"), upload: t("MediaModal_Tabs_Upload") };
  const initialUrl = (src == null ? void 0 : src.url) || "";
  const isEmbedType = embedType || (src == null ? void 0 : src.url);
  const [activeTab, setActiveTab] = useState(isEmbedType ? audioTabs.embed : audioTabs.upload);
  const [url, setUrl] = useState(initialUrl);
  const [submittedInvalidUrl, setSubmittedInvalidUrl] = useState(false);
  const { onPluginsPopOverTabSwitch, onPluginsPopOverClick } = helpers || {};
  const onTabSelected = (tab) => {
    onPluginsPopOverTabSwitch == null ? void 0 : onPluginsPopOverTabSwitch({
      pluginId: AUDIO_TYPE,
      buttonName: MEDIA_POPOVERS_TABS_NAMES_BI[tab.toLowerCase()]
    });
    setActiveTab(tab);
  };
  const onEmbedClick = () => {
    onPluginsPopOverClick == null ? void 0 : onPluginsPopOverClick({
      pluginId: AUDIO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
    });
    if (url && isSoundcloudUrl(url)) {
      onAudioEmbed(url);
    } else if (url && ReactPlayer.canPlay(url)) {
      const _a2 = componentData, rest = __objRest(_a2, ["audio", "name", "coverImage", "authorName", "disableDownload", "html"]);
      const { onConfirm: onConfirm2 } = props;
      if (onConfirm2) {
        onConfirm2(__spreadProps(__spreadValues({}, rest), { audio: { src: { url } } }));
      }
      if (onReplace) {
        onReplace(__spreadProps(__spreadValues({}, rest), { audio: { src: { url } } }));
      } else {
        setData == null ? void 0 : setData(__spreadProps(__spreadValues({}, rest), { audio: { src: { url } } }));
      }
      closeModal == null ? void 0 : closeModal();
    } else {
      onAudioEmbed(url);
    }
  };
  const onAudioEmbed = (url2) => {
    const { fetchData } = props;
    const _a2 = componentData, rest = __objRest(_a2, ["audio", "name", "coverImage", "authorName", "disableDownload"]);
    if (url2) {
      fetchData(url2).then(({ html }) => {
        if (!html) {
          setSubmittedInvalidUrl(true);
        } else {
          if (onConfirm) {
            onConfirm(__spreadProps(__spreadValues({}, rest), { audio: { src: { url: url2 } }, html }));
          }
          if (onReplace) {
            onReplace(__spreadProps(__spreadValues({}, rest), { audio: { src: { url: url2 } }, html }));
          } else {
            setData == null ? void 0 : setData(__spreadProps(__spreadValues({}, rest), { audio: { src: { url: url2 } }, html }));
          }
          closeModal == null ? void 0 : closeModal();
        }
      });
    }
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.audio_modal_container, {
        [styles.audio_modal_mobile]: isMobile
      }),
      "data-hook": ADD_AUDIO_MODAL
    },
    showCloseButton && /* @__PURE__ */ React.createElement(ModalHeaderWithCloseButton, { title: t("Audio_Modal_Header_Title"), closeModal }),
    /* @__PURE__ */ React.createElement("div", { className: styles.audio_modal_content }, isMobile && /* @__PURE__ */ React.createElement(
      SettingsMobileHeader,
      {
        onCancel: () => closeModal(),
        t,
        title: t("AudioPlugin_Settings_Header"),
        showSaveBtn: false
      }
    ), /* @__PURE__ */ React.createElement(
      Tabs,
      {
        value: activeTab,
        onTabSelected,
        headersStyle: isMobile ? styles.audio_tabs_headers : void 0
      },
      /* @__PURE__ */ React.createElement(Tab, { label: audioTabs.upload, value: audioTabs.upload }, /* @__PURE__ */ React.createElement("div", { className: classNames(styles.audio_modal_tab, styles.audio_upload_tab) }, /* @__PURE__ */ React.createElement(AudioUploadModal, __spreadValues({}, props)))),
      /* @__PURE__ */ React.createElement(Tab, { label: audioTabs.embed, value: audioTabs.embed }, /* @__PURE__ */ React.createElement("div", { className: styles.audio_modal_tab }, /* @__PURE__ */ React.createElement(
        MediaURLInputModal,
        __spreadProps(__spreadValues({}, props), {
          onConfirm: onEmbedClick,
          url,
          setUrl,
          languageDir,
          submittedInvalidUrl,
          withMobileHeader: false,
          dataHook: EMBED_TAB_AUDIO_INPUT,
          saveLabel: t("AudioModal_Embed_ButtonText"),
          subTitle: t("AudioModal_Embed_Title"),
          helpers,
          t,
          isMobile
        })
      )))
    ))
  );
};

export { AudioInsertModal as default };
//# sourceMappingURL=AudioInsertModal.js.map
